import { Accessor } from '@deck.gl/core';
import { _MultiIconLayer as MultiIconLayer } from '@deck.gl/layers';
import hiddable from '../../modules/isHiddableModule.js';
import { globeHorizonClipModule } from '../../modules/hide-opposite-globe.js';

export class HidableMultiIconLayer<TData, TExtraProps = object> extends MultiIconLayer<
    TData,
    TExtraProps & {
        getIsHidden: Accessor<TData, 0 | 1>;
    }
> {
    initializeState() {
        super.initializeState();
        this.getAttributeManager()!.addInstanced({
            isHidden: {
                size: 1,
                accessor: 'getIsHidden',
                defaultValue: 0.0
            }
        });
    }

    getShaders() {
        const parentShaders = super.getShaders();
        return {
            ...parentShaders,
            modules: [...parentShaders.modules, hiddable, globeHorizonClipModule]
        };
    }
}
